import { useQuery } from '@tanstack/react-query';
import { Challenge } from 'types';
import { getPlayers } from '../API';

export const playersQueryKey = 'players';

export function useGetPlayers(challengeId: Challenge['id']) {
  return useQuery([playersQueryKey, challengeId], () => getPlayers(challengeId));
}
